import { User, Role, Capability } from '../../types';
import { createRepo } from '../repo';
import { loadJSON, saveJSON } from '../storage';
import { DB_KEYS } from '../dbKeys';
import { DEFAULT_ROLE_POLICIES } from '../../constants';
import { broadcast } from '../bus';

import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../../src/firebase';

const userRepo = createRepo<User>(DB_KEYS.USERS);

export const ROLE_POLICIES_DOC_ID = 'role_policies';
export const SETTINGS_COLLECTION = 'settings';

export const getUsers = async () => (await userRepo.list()).data;
export const addUser = (item: Omit<User, 'id'>) => userRepo.create(item);
export const updateUser = (item: User) => userRepo.update(item.id, item);
export const deleteUser = (id: string) => userRepo.remove(id);

export const getRolePolicies = async (tenantId?: string | null): Promise<Record<Role, Capability[]>> => {
    if (tenantId) {
        try {
            const docRef = doc(db, 'organizations', tenantId, SETTINGS_COLLECTION, ROLE_POLICIES_DOC_ID);
            const snap = await getDoc(docRef);
            if (snap.exists()) {
                return snap.data().policies as Record<Role, Capability[]>;
            }
        } catch (e) {
            console.error("[users api] Failed to fetch role policies from Firestore:", e);
        }
    }
    return await loadJSON(DB_KEYS.ROLE_POLICIES, DEFAULT_ROLE_POLICIES);
};

export const saveRolePolicies = async (policies: Record<Role, Capability[]>, tenantId?: string | null) => {
    if (tenantId) {
        try {
            const docRef = doc(db, 'organizations', tenantId, SETTINGS_COLLECTION, ROLE_POLICIES_DOC_ID);
            await setDoc(docRef, {
                policies,
                updatedAt: serverTimestamp()
            }, { merge: true });
        } catch (e) {
            console.error("[users api] Failed to save role policies to Firestore:", e);
        }
    }

    // Always update local storage for backward compatibility and offline support
    await saveJSON(DB_KEYS.ROLE_POLICIES, policies);
    broadcast('policies');
};
